import React from "react";
import { SectionHeading, PillLink } from "../components/common";
import { GuideMascot } from "../components/GuideMascot";
import { PILLARS, GUIDES } from "../data/content";

const Pillars = () => {
  return (
    <div data-testid="pillars-page">
      <section className="bg-[#FDFBF7] pt-14 pb-16">
        <div className="mx-auto max-w-4xl px-5 md:px-8 text-center">
          <span className="font-hand text-2xl text-[#4A90E2]">The whole child</span>
          <h1 className="font-head font-700 tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#1E293B] mt-1">Our Five Pillars</h1>
          <p className="mt-4 font-body text-lg text-[#475569] leading-relaxed">
            Everything we do is rooted in five interconnected pillars that nurture the whole child. We believe every child deserves to be supported in their Body, Mind, Heart, Soul & Spirit.
          </p>
          <div className="mt-6 flex justify-center">
            <GuideMascot src={GUIDES.leaf} size={140} ring="#84A98C" className="animate-floaty" />
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="mx-auto max-w-6xl px-5 md:px-8 space-y-8">
          {PILLARS.map((p, i) => (
            <div
              key={p.key}
              data-testid={`pillar-${p.key}`}
              className={`flex flex-col md:flex-row items-center gap-8 rounded-[2rem] p-8 md:p-10 shadow-soft-sm ${i % 2 ? "md:flex-row-reverse" : ""}`}
              style={{ background: p.tint }}
            >
              <div className="shrink-0 w-28 h-28 rounded-3xl bg-white grid place-items-center text-6xl shadow-soft-sm">{p.emoji}</div>
              <div className="flex-1 text-center md:text-left">
                <h2 className="font-head font-700 text-3xl" style={{ color: p.color }}>{p.title}</h2>
                <p className="mt-1 font-body font-600 text-[#1E293B]">{p.blurb}</p>
                <p className="mt-3 font-body text-[#475569] leading-relaxed">{p.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-[#4A90E2]">
        <div className="mx-auto max-w-3xl px-5 md:px-8 text-center text-white">
          <p className="font-body text-lg md:text-xl leading-relaxed">
            Every lesson, every meal, every outdoor adventure, every creative project, and every relationship at Divinities Cove is intentionally designed to nurture the whole child — creating a holistic learning experience where little ones are free to learn, grow, and shine. 🌿✨
          </p>
          <div className="mt-8"><PillLink to="/programs" variant="yellow" testid="pillars-to-programs">See Our Programs</PillLink></div>
        </div>
      </section>
    </div>
  );
};

export default Pillars;
